jQuery(document).ready(function(jQuery) {
  
  /*################### Home Pages ######################*/

  /* Sticky Header */
  function sticky_section() {

    var header_h = jQuery('.site-header').height();

    jQuery(window).scroll(function(){
      var sticky = jQuery('.site-header'),
          scroll = jQuery(window).scrollTop();

      if (scroll >= 1){
        sticky.addClass('fixed');
        jQuery('body').addClass('fixed');
        jQuery('body').css('padding-top', header_h);
        jQuery('.announcement-bar').hide();
        
      }
      else {
        sticky.removeClass('fixed');
        jQuery('body').removeClass('fixed');
        jQuery('body').css('padding-top', '0');
        jQuery('.announcement-bar').show();
      }
    });
  }
  sticky_section();
  jQuery(window).on('load resize orientationchange', sticky_section);
  
  /* Scroll Button */
  jQuery(document).on('click', '.scroll-btn', function(event) {
    var jQueryanchor = jQuery(this);
    jQuery('html, body').stop().animate({
      scrollTop: jQuery(jQueryanchor.attr('href')).offset().top
    }, 1500, 'easeInOutExpo');
    event.preventDefault();
  });
  
  /* About content */
  jQuery(".about-section .icon-flag-uk").click(function(){
    jQuery(".about-section .british-content").show();
    jQuery(".about-section .irish-content").hide();
    jQuery(this).addClass("active-flag");
    jQuery(".about-section .icon-flag-ie").removeClass("active-flag");
  });
  
  jQuery(".about-section .icon-flag-ie").click(function(){
    jQuery(".about-section .british-content").hide();
    jQuery(".about-section .irish-content").show();
    jQuery(this).addClass("active-flag");
    jQuery(".about-section .icon-flag-uk").removeClass("active-flag");
  });
  
  /* Footer content */
  jQuery("footer .language-switcher .icon-flag-uk").click(function(){
    jQuery("footer .british-content").show();
    jQuery("footer .irish-content").hide();
    jQuery(this).addClass("active-flag");
    jQuery("footer .language-switcher .icon-flag-ie").removeClass("active-flag");
  });
  
  jQuery("footer .language-switcher .icon-flag-ie").click(function(){
    jQuery("footer .british-content").hide();
    jQuery("footer .irish-content").show();
    jQuery(this).addClass("active-flag");
    jQuery("footer .language-switcher .icon-flag-uk").removeClass("active-flag");
  });
  
  /* Banner Slider */ 
  jQuery('.js-banner-slider').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplaySpeed:3500,
    autoplay: true,
    adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
  
  /* Featured Products */
  jQuery('.js-product-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplaySpeed:5000,
    autoplay: true,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
  
  jQuery('.js-product-slider-3').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplaySpeed:5000,
    autoplay: true,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
  
  /* Logo Slider */
  jQuery('.js-logo-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplaySpeed:5000,
    autoplay: true,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
  
  /*################### Collection Pages ######################*/
  
  /* Sidebar */
  //jQuery(".f-accordion-content").hide(); 
  jQuery(".f-accordion-title").click(function(){
    var thisBlock = jQuery(this).parent().index('.f-accordion-block');
    jQuery(".f-accordion-block").find(".active").not(jQuery(this)).removeClass("active");
    jQuery(this).toggleClass("active").next().slideToggle();
    jQuery(this).parent().toggleClass("activeToggle").siblings()
    .removeClass("activeToggle").children(".f-accordion-content").hide();
    return false;
  });

  /*################### Product Pages ######################*/
  
  
  
  /* Product Slider */
  function product_slider() {
    // if ($(window).width() >= 750) {
      jQuery('.slider-active .product-single__thumbnails-slider-track').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        autoplaySpeed: 5000,
        autoplay: false,
        centerMode: false,
        focusOnSelect: true,
        adaptiveHeight: false,
        prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
        slidesToShow: 3,
        slidesToScroll: 1,
        rows: 0,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 479,
            settings: {
              slidesToShow: 2,
            }
          }
        ]
      })
      .on('setPosition', function (event, slick) {
        slick.$slides.css('height', slick.$slideTrack.height() + 'px');
      });
    // }
  }
  
  product_slider();
  jQuery(window).on('load resize orientationchange', product_slider);
  
  /* Product Tab */
  $('ul.tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  });
  
  /*################### About Pages ######################*/
  
  /* Brand Collection */
  function brand_section() {
    var full_width = jQuery('body').width();
    var container = jQuery('.container').width();

    var temp_padding = full_width - container;
    var final_padding = temp_padding / 2;
    jQuery(".image_left .block-content").css('padding-right', final_padding);
    jQuery(".image_right .block-content").css('padding-left', final_padding);
    
  }
  brand_section();
  jQuery(window).on('load resize orientationchange', brand_section);
  
  
   /* Accordion */ 
  $(".accordion-content").hide(); 
  $(".accordion-title").click(function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      $('.accordion-content').slideUp();
      $('.accordion-title').not(this).removeClass('active');
      $('.accordion-block').removeClass('activeToggle');
      $(this).addClass('active');
      $(this).next('.accordion-content').slideDown();
      $(this).parent().addClass("activeToggle"); 
    } else {
      $(this).removeClass('active');
      $(this).next('.accordion-content').slideUp();
      $(this).parent().removeClass("activeToggle"); 	
    }
  });

});

// CD Sanket
$('.federation_item_img_link').on('click', function(){
  if($(this).attr('href') != "#"){
      window.location.href = $(this).attr('href');
  }
})